import * as React from 'react';

import * as styles from './FavoritesFolders.css';

interface IFavoritesFoldersProps {
  children: React.ReactNode;
}

export function FavoritesFolders({ children }: IFavoritesFoldersProps) {
  return <div className={styles['container']}>{children}</div>;
}
